/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Bike
 *
 * 1 = Car
 *
 * 2 = Caravan
 *
 * 3 = Crossover
 *
 * 4 = Farm
 *
 * 5 = Motorhome
 *
 * 6 = Plant
 *
 * 7 = Truck
 *
 * 8 = Van
 */
export enum AutotraderVehicleTypes {
  Bike = 0,
  Car = 1,
  Caravan = 2,
  Crossover = 3,
  Farm = 4,
  Motorhome = 5,
  Plant = 6,
  Truck = 7,
  Van = 8,
}
